<template>
    <div class="project-approval-page">
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="header-left">
                <i class="el-icon-s-order"></i>
                <h2>{{ activeMainText }}</h2>
            </div>
        </div>
        <!-- 横向时间线分类区域 -->
        <div class="timeline-section">
            <div class="timeline-container">
                <div class="timeline-block" :class="{ 'is-active': activeMain === 0 }" @click="selectMain({ label: '产业链上游', value: 0 })">
                    <div class="main-category-header mt-1">
                        <span class="main-name">全部</span>
                        <!-- <span class="sub-name">{{ getSubLabel(mainItem.label) }}</span> -->
                    </div>
                </div>
                <div v-for="(mainItem, mainIndex) in mainCategories" :key="mainIndex" class="timeline-block"
                    :class="{ 'is-active': activeMain === mainItem.value }" @click="selectMain(mainItem)">
                    <div class="main-category-header">
                        <span class="main-name">{{ mainItem.label }}</span>
                        <span class="sub-name">{{ getSubLabel(mainItem.label) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 筛选区域 -->
        <div class="filter-section">
            <el-form :model="searchFilter" ref="searchForm" label-position="left" class="projectForm">
                <el-row>
                    <!-- 采购项目名称 -->
                    <el-col :span="12">
                        <el-form-item label="采购项目名称" :label-width="labelWidth">
                            <el-input class="text-input" v-model="searchFilter.projectName" placeholder="请输入采购项目名称"
                                clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 项目业主名称 -->
                    <el-col :span="12">
                        <el-form-item label="项目业主名称" :label-width="labelWidth">
                            <el-input class="text-input" v-model="searchFilter.purchaserName" placeholder="请输入项目业主名称"
                                clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!-- 中选中介机构名称 -->
                    <el-col :span="12">
                        <el-form-item label="中选中介机构名称" :label-width="labelWidth">
                            <el-input class="text-input" v-model="searchFilter.bidAgentName" placeholder="请输入中选中介机构名称"
                                clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 地区级联 -->
                    <el-col :span="12">
                        <el-form-item label="地区" :label-width="labelWidth">
                            <el-select class="seletc-size-input" v-model="searchFilter.province" placeholder="省份"
                                @change="areaChange($event, 'province')">
                                <el-option v-for="item in provinceList" :key="item.areaId" :label="item.areaName"
                                    :value="item.areaId"></el-option>
                            </el-select>
                            <el-select class="seletc-size-input" v-model="searchFilter.city" placeholder="城市"
                                @change="areaChange($event, 'city')">
                                <el-option v-for="item in cityList" :key="item.areaId" :label="item.areaName"
                                    :value="item.areaId"></el-option>
                            </el-select>
                            <el-select class="seletc-size-input" v-model="searchFilter.county" placeholder="区县">
                                <el-option v-for="item in countyList" :key="item.areaId" :label="item.areaName"
                                    :value="item.areaId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!-- 项目规模（万元） -->
                    <el-col :span="12">
                        <el-form-item label="项目规模（万元）" :label-width="labelWidth">
                            <div class="range-input">
                                <el-input class="num-size-input" v-model="searchFilter.projectScaleMin"
                                    placeholder="最小值"></el-input>
                                <span class="range-separator"> - </span>
                                <el-input class="num-size-input" v-model="searchFilter.projectScaleMax"
                                    placeholder="最大值"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <!-- 服务金额（万元） -->
                    <el-col :span="12">
                        <el-form-item label="服务金额（万元）" :label-width="labelWidth">
                            <div class="range-input">
                                <el-input class="num-size-input" v-model="searchFilter.servicePriceMin"
                                    placeholder="最小值"></el-input>
                                <span class="range-separator"> - </span>
                                <el-input class="num-size-input" v-model="searchFilter.servicePriceMax"
                                    placeholder="最大值"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!-- 服务金额百分比 -->
                    <el-col :span="12">
                        <el-form-item label="服务金额百分比" :label-width="labelWidth">
                            <div class="range-input">
                                <el-input class="num-size-input" v-model="searchFilter.servicePercentMin" :precision="2"
                                    placeholder="最小值"></el-input>
                                <span class="range-separator"> - </span>
                                <el-input class="num-size-input" v-model="searchFilter.servicePercentMax"
                                    placeholder="最大值"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <!-- 合同时间 -->
                    <el-col :span="12">
                        <el-form-item label="合同时间" :label-width="labelWidth">
                            <div class="range-input">
                                <el-date-picker v-model="searchFilter.contractDateMin" type="date" placeholder="起始日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                                <span class="range-separator">- </span>
                                <el-date-picker v-model="searchFilter.contractDateMax" type="date" placeholder="截止日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!-- 服务终止时间 -->
                    <el-col :span="12">
                        <el-form-item label="服务终止时间" :label-width="labelWidth">
                            <div class="range-input">
                                <el-date-picker v-model="searchFilter.terminationDateMin" type="date" placeholder="起始日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                                <span class="range-separator">- </span>
                                <el-date-picker v-model="searchFilter.terminationDateMax" type="date" placeholder="截止日期"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同金额" :label-width="labelWidth">
                            <div class="range-input">
                                <el-input class="num-size-input" v-model="searchFilter.contractPriceMin"
                                    placeholder="最小值"></el-input>
                                <span class="range-separator"> - </span>
                                <el-input class="num-size-input" v-model="searchFilter.contractPriceMax"
                                    placeholder="最大值"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!-- 服务终止时间 -->
                    <el-col :span="12">
                        <el-form-item label="行业" :label-width="labelWidth">
                            <el-select class="seletc-size-input-1" v-model="searchFilter.industry" placeholder="行业">
                                
                                <el-option v-for="item in industryList" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="btn oh mr-8 mb-2">
                <div class="fr">
                    <el-button icon="el-icon-search" type="primary" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
                </div>
            </div>
        </div>

        <ad :type="1"></ad>
        
        <!-- 数据表格区域 -->
        <div class="table-section">
            <div class="table-header">
                <div class="table-title">
                    <i class="el-icon-document-checked"></i>
                    <span>{{ activeMainText }}</span>
                    <el-tag size="small" type="info">{{ total }} 条</el-tag>
                </div>
                <div class="fr" v-if="curWebsite.type == 3">
                    <el-button type="primary" icon="el-icon-download" :loading="exportDataLoading" @click="exportData">导出数据</el-button>
                </div>
            </div>
            

            <el-table :data="tableData" stripe border v-loading="loading" class="data-table"
                :header-cell-style="headerCellStyle">
                <el-table-column prop="index" width="60" align="center" label="序号">
                    <template slot-scope="{ $index }">
                        {{ $index + 1 + (currentPage - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" min-width="160" align="left" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <el-link type="primary" :underline="false"
                            @click="handleViewDetail(row)">
                            <span class="code-text">{{ row.projectName || '-' }}</span>
                        </el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="projectCode" label="项目名称" min-width="150" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text">{{ row.projectName || '-' }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="projectCode" label="中选机构" min-width="130" align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text">{{ row.bidAgentName || '-' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="projectCode" label="服务金额（万元）" align="center" min-width="100"
                    show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text" v-if="row.minServicePrice>0 || row.minServicePrice>0">{{ row.minServicePrice +' 至 '+ row.minServicePrice || '-' }}</span>
                        <span class="code-text" v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="projectCode" label="服务金额百分百" align="center" min-width="80" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text" v-if="row.minServicePercent>0 || row.maxServicePercent>0">{{ row.minServicePercent +' 至 '+ row.maxServicePercent || '-' }}</span>
                        <span class="code-text" v-else>-</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="projectCode" label="项目规模" align="center" min-width="120" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text">{{ formatScaleValue(row.restrictions) || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="progress" label="城市" width="170" align="center">
                    <template slot-scope="{ row }">
                        {{ row.province }}{{ row.city }}{{ row.county }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="合同时间" width="120" align="center">
                    <template slot-scope="{ row }">
                        {{ row.contractDate || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center" fixed="right">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small"
                            @click="handleViewDetail(row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background />
            </div>
        </div>

    </div>
</template>

<script>
import { dataInJs } from '@/utils/city.js';
import { downloadBlob,getTimestamp } from '@/utils/utils.js';
import axios from 'axios';
export default {
    name: 'agencyService',
    components: {
    },
    data() {
        return {
            mainCategories: [],
            labelWidth: '160px',
            activeMain: 0,
            activeMainText: '产业链上游项目',
            curWebsite:this.$api.getWebsiteType(),

            // 查询参数（与接口字段一一对应）
            searchFilter: {
                projectName: '',
                purchaserName: '',
                bidAgentName: '',
                projectScaleMin: undefined,
                projectScaleMax: undefined,
                servicePriceMin: undefined,
                servicePriceMax: undefined,
                servicePercentMin: undefined,
                servicePercentMax: undefined,
                contractPriceMax: undefined,
                contractPriceMin: undefined,
                contractDateMin: '',
                contractDateMax: '',
                terminationDateMin: '',
                terminationDateMax: '',
                province: 44,
                city: undefined,
                county: undefined,
                industry: undefined
            },
            provinceList: dataInJs(),
            cityList: [],
            countyList: [],
            industryList: [],
            exportDataLoading:false,
            // 表格数据
            loading: false,
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
    },
    created() {
        this.searchFilter.province = 44;
        this.cityList = this.provinceList.filter(item => item.areaId === 44)[0].children;
    },
    mounted() {
        this.getCategoryName();
        this.fetchData();
        this.getIndustryList();
    },

    methods: {
        // 导出方法
        async  exportData() {
        let ajaxUrl = this.$api.common.agencyService.Export();
        const dataParams = {
                ...this.searchFilter,
                category: this.activeMain,
            };
        this.exportDataLoading = true;
        try {
            const response = await axios({
            url: ajaxUrl,
            method: 'POST',
            data: dataParams,
            responseType: 'blob',        // 关键：指定响应类型为 blob
            timeout: 60000,            // 导出可能较慢，设长一点
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });

            console.log('导出数据', response);
            // 从响应头获取文件名（后端设置 Content-Disposition）
            const headers = response.headers || {}

            // 取文件名
            const dateStr = getTimestamp();
            let filename = `中介服务数据​_${dateStr}.xlsx`;

            downloadBlob(response.data, filename);
            this.exportDataLoading = false;
        } catch (error) {
            console.error('导出失败', error);
            this.$message.error('导出失败，请重试');
        }
        },
        getIndustryList() {
            let ajaxUrl = this.$api.common.agencyService.Industry();
            this.loading = true;
            this.$axios.get(ajaxUrl).then((res) => {
                if (res.success) {
                    this.industryList = res.list;
                }
                this.loading = false;
            }).catch((err) => {
                console.error('fetchData err:', err);
                this.loading = false;
            });
        },
        //详情跳转
        handleViewDetail(row) {
            // console.log(row.detail == 'Detail');
            // return;
            if(row.detail == 'Detail'){
                this.handlerLinkLocal('/agencyService/detail?id=' + row.id);
            }else if(row.detail == 'DetailGD'){  //广东
                this.handlerLinkLocal('/agencyService/detailGD?id=' + row.id);
            }else if(row.detail == 'DetailSZ'){  //深圳
                this.handlerLinkLocal('/agencyService/detailSZ?id=' + row.id);
            }else{  //其他
                this.handlerLinkLocal('/agencyService/detail?id=' + row.id);
            }
            
        },

        formatScaleValue(str) {
            // 如果为空或者没有值，直接返回 '-'
            if (!str) return '-';

            // 使用正则匹配全角或半角括号内的内容
            // 匹配规则：找到 （ 或 ( ，捕获中间的内容，直到遇到 ） 或 )
            const match = str.match(/[（(](.+?)[）)]/);

            if (match && match[1]) {
                // match[1] 就是括号里的内容，例如 "¥270,000,000元" 或 "1,000平方米"
                let result = match[1];

                // 去掉开头的货币符号 (¥, ￥, $ 等)
                result = result.replace(/^[¥￥$]/, '');

                return result;
            }

            // 如果没有匹配到括号（比如输入的是 "其他"），则返回 '-'
            return '-';
        },
        // 选择主分类
        selectMain(item) {
            this.activeMain = item.value;
            this.activeMainText = item.label;
            this.currentPage = 1;
            this.handleReset();
            this.fetchData();
        },

        // 查询
        handleSearch() {
            this.currentPage = 1;
            this.fetchData();
        },

        // 重置
        handleReset() {
            this.searchFilter = {
                projectName: '',
                purchaserName: '',
                bidAgentName: '',
                projectScaleMin: undefined,
                projectScaleMax: undefined,
                servicePriceMin: undefined,
                servicePriceMax: undefined,
                servicePercentMin: undefined,
                servicePercentMax: undefined,
                contractDateMin: '',
                contractDateMax: '',
                terminationDateMin: '',
                terminationDateMax: '',
                province: 44,
                
                city: undefined,
                county: undefined,
                industry: undefined
            };
            this.cityList = this.provinceList.filter(item => item.areaId === 44)[0].children;
            this.countyList = [];
            this.currentPage = 1;
            this.fetchData();
        },

        // 拉取列表（自动拼接 category + page）
        fetchData() {
            const params = {
                ...this.searchFilter,
                category: this.activeMain,
                page: this.currentPage,
            };

            // 过滤空值，减少无效参数
            Object.keys(params).forEach(key => {
                if (params[key] === undefined || params[key] === '' || params[key] === null) {
                    delete params[key];
                }
            });

            let ajaxUrl = this.$api.common.agencyService.List();
            this.loading = true;
            this.$axios.get(ajaxUrl, { params }).then((res) => {
                if (res.success) {
                    this.tableData = res.list;
                    this.total = res.totalRecord;
                    // this.activeMainText = this.mainCategories.filter(item => item.value === this.activeMain)[0].label;
                }
                this.loading = false;
            }).catch((err) => {
                console.error('fetchData err:', err);
                this.loading = false;
            });
        },

        // 地区级联
        areaChange(val, type) {
            if (type === 'province') {
                this.cityList = this.provinceList.filter(item => item.areaId === val)[0].children;
                this.countyList = [];
                this.searchFilter.city = '';
                this.searchFilter.county = '';
            } else if (type === 'city') {
                this.countyList = this.cityList.filter(item => item.areaId === val)[0].children;
            } else if (type === 'county') {
                // 选择县区后不需要做额外操作
            }
        },

        getCategoryName() {
            let ajaxUrl = this.$api.common.agencyService.Category();
            this.$axios.get(ajaxUrl).then((res) => {
                if (res.success) {
                    this.mainCategories = res.list;
                }
            }).catch((err) => {
                console.log('getCategoryName err:', err);
            });
        },

        getSubLabel(label) {
            const map = {
                '决策咨询': '项目建议书/可研',
                '专项评估': '环评/能评/水保/交评等',
                '勘察设计': '测绘/勘察/设计',
                '施工图审查': '施工图审查',
                '工程造价': '估算/概算/预算/结算',
                '招标代理': '招标代理',
                '工程监理': '工程监理',
                '施工竣工服务': '监测/检测/验收/决算',
                '总承包': '工程总承包',
            };
            return map[label] || '';
        },

        headerCellStyle() {
            return {
                backgroundColor: '#2c5282',
                color: '#fff',
                fontWeight: 600,
                fontSize: '14px'
            };
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },

        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        }
    }
}
</script>

<style lang="less" scoped>
.project-approval-page {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);

    // 页面头部
    .page-header {
        margin-bottom: 20px;
        padding: 0 5px;

        .header-left {
            display: flex;
            align-items: center;

            i {
                font-size: 24px;
                color: #2c5282;
                margin-right: 10px;
            }

            h2 {
                font-size: 20px;
                font-weight: 600;
                color: #1a365d;
                margin: 0;
            }
        }
    }

    // 横向时间线分类区域
    .timeline-section {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        margin-bottom: 20px;
        overflow: hidden;
    }

    .timeline-container {
        display: flex;
        width: 100%;
    }

    .timeline-block {
        flex: 1;
        position: relative;
        padding: 16px 8px 14px;
        text-align: center;
        cursor: pointer;
        background: #fff;
        border-right: 1px solid #e2e8f0;
        transition: all 0.25s ease;
        user-select: none;

        &:last-child {
            border-right: none;
        }

        // 悬停效果（未激活时）
        &:not(.is-active):hover {
            background: #f7fafc;

            .main-name {
                color: #2c5282;
            }
        }

        // 主分类标题
        .main-category-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
        }

        .main-name {
            font-size: 16px;
            font-weight: 600;
            color: #2d3748;
            transition: color 0.25s ease;
            letter-spacing: 0.5px;
        }

        // 副标题说明（不可点击，仅展示）
        .sub-name {
            font-size: 14px;
            color: #a0aec0;
            font-weight: 400;
            pointer-events: none;
            line-height: 1.4;
        }

        // 激活状态
        &.is-active {
            background: #2c5282;

            .main-name {
                color: #fff;
                font-weight: 700;
            }

            .sub-name {
                color: rgba(255, 255, 255, 0.65);
            }

            &:hover {
                background: #2c5282;
            }
        }
    }

    // 筛选区域
    .filter-section {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

        .filter-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
        }

        .filter-item {
            display: flex;
            align-items: center;

            .filter-label {
                font-size: 14px;
                color: #4a5568;
                margin-right: 10px;
                font-weight: 500;
                white-space: nowrap;
            }

            &.search-item {
                flex: 1;
                max-width: 300px;
            }
        }

        .date-picker {
            width: 280px;
        }

        .location-picker {
            width: 200px;
        }

        .search-input {
            width: 100%;
        }

        .filter-actions {
            margin-left: auto;

            .el-button {
                margin-left: 10px;
            }
        }
    }

    // 表格区域
    .table-section {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

        .table-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .table-title {
                display: flex;
                align-items: center;

                i {
                    font-size: 18px;
                    color: #2c5282;
                    margin-right: 8px;
                }

                span {
                    font-size: 16px;
                    font-weight: 600;
                    color: #1a365d;
                    margin-right: 10px;
                }

                .el-tag {
                    font-weight: normal;
                }
            }
        }

        // 表格样式
        .data-table {
            border-radius: 6px;
            overflow: hidden;
            font-size: 16px;

            ::v-deep .el-table__header-wrapper {
                th {
                    background-color: #2c5282 !important;
                }
            }

            .code-text {
                color: #4a5568;
                font-size: 16px;
                letter-spacing: 0.5px;
            }

            .status-dot {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 6px;

                &.active {
                    background: #48bb78;
                    box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
                }

                &.inactive {
                    background: #cbd5e0;
                }
            }

            .date-icon {
                color: #2c5282;
                margin-right: 4px;
            }

            ::v-deep .el-link {
                font-weight: 500;
            }
        }

        // 分页
        .pagination-wrapper {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
    background: #2c5282;
    border-color: #2c5282;

    &:hover,
    &:focus {
        background: #1a365d;
        border-color: #1a365d;
    }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
    color: #2c5282;

    &:hover {
        color: #1a365d;
    }
}
</style>